import React from "react";
import { Award, Calendar, Phone, Globe, CheckCircle } from "lucide-react";
import { styles as baseStyles } from "../../style/DoctorProfile.styles";

/**
 * ProfessionalDetails
 *
 * Props:
 * - doctor: {
 *     experience?: string,
 *     startedPracticeYear?: number,
 *     phone?: string,
 *     languages?: string[],
 *     certifications?: string[]
 *   }
 * - styles?: typeof baseStyles
 */
const ProfessionalDetails = ({ doctor = {}, styles = baseStyles }) => {
  const { experience, startedPracticeYear, phone, languages = [], certifications = [] } = doctor;

  return (
    <div style={styles.section}>
      <div style={styles.sectionHeader}>
        <Award style={{ width: 20, height: 20, color: "#8b5cf6" }} />
        <h2 style={styles.sectionTitle}>Professional Details</h2>
      </div>

      <div style={styles.sectionContent}>
        {/* Simple info list */}
        <ul style={styles.infoList}>
          {experience && (
            <li style={styles.infoItem}>
              <Award style={styles.infoIcon} />
              <span style={styles.infoLabel}>Experience:</span>
              <span style={styles.infoValue}>{experience}</span>
            </li>
          )}

          {startedPracticeYear && (
            <li style={styles.infoItem}>
              <Calendar style={styles.infoIcon} />
              <span style={styles.infoLabel}>Started Practice:</span>
              <span style={styles.infoValue}>{startedPracticeYear}</span>
            </li>
          )}

          {phone && (
            <li style={styles.infoItem}>
              <Phone style={styles.infoIcon} />
              <span style={styles.infoLabel}>Phone:</span>
              <span style={styles.infoValue}>{phone}</span>
            </li>
          )}
        </ul>

        {/* Languages */}
        {languages.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <h3
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#111827",
                marginBottom: 12,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <Globe style={{ width: 16, height: 16 }} />
              Languages
            </h3>
            <div style={styles.tagList}>
              {languages.map((lang, i) => (
                <span key={`${lang}-${i}`} style={styles.tag}>
                  {lang}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Certifications */}
        {certifications.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <h3
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#111827",
                marginBottom: 12,
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <CheckCircle style={{ width: 16, height: 16 }} />
              Certifications
            </h3>
            <div style={styles.tagList}>
              {certifications.map((cert, i) => (
                <span key={`${cert}-${i}`} style={styles.tag}>
                  {cert}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfessionalDetails;
